import React from 'react';
import { aboutMe } from '../data/mock';
import '../styles/About.css';

const About = () => {
  return (
    <section className="about-section" id="about">
      <div className="about-container">
        <h2 className="section-title">About Me</h2>
        
        <div className="about-content">
          <p className="about-description">{aboutMe.description}</p>
        </div>
      </div>
    </section>
  );
};

export default About;